import React, { useState, useEffect } from "react";
import { Automations } from "./Automations";
import { Scenarios } from "./Scenarios";
import { useTranslation } from "react-i18next";
const AutoOrSen = () => {
  const { t } = useTranslation();
  const [x, setX] = useState(false);
  const [isPhone, setIsPhone] = useState(false);
  const [viewIndex, setViewIndex] = useState(0);
  const showSenarios = () => {
    setX(false);
    setViewIndex(0);
  };
  const showAutomation = () => {
    setX(true);
    setViewIndex(2);
  };
  useEffect(() => {
    var width = Math.max(window.screen.width, window.innerWidth);
    if (width <= 992) {
      setIsPhone(true);
    }
  }, []);
  return (
    <>
      {/* <div className="d-flex align-items-center justify-content-between w-100 mb-2 ">
        <div className="d-flex gap-2">
          <i
            className={`d-block widgetDisplayIcons cursor 
                    text-center  gap-2 
                  d-flex align-items-center justify-content-center
                    mx-1 
                    ${isPhone ? "rounded-circle phoneView" : "rounded-5"}
                                    ${
                                      viewIndex === 0
                                        ? "bg-priimary text-white"
                                        : "bg-white"
                                    }`}
            onClick={showSenarios}
          >
            {isPhone ? (
              <span>
                {" "}
                <i className="icon-lump"></i>
              </span>
            ) : (
              <span className="m-2"> {t("سناریو ها")}</span>
            )}
          </i>
          <i
            className={`d-block widgetDisplayIcons cursor 
                    text-center  gap-2 
                  d-flex align-items-center justify-content-center
                    mx-1 
                    ${isPhone ? "rounded-circle phoneView" : "rounded-5"}
                                    ${
                                      viewIndex === 2
                                        ? "bg-priimary text-white"
                                        : "bg-white"
                                    } mx-1`}
            onClick={showAutomation}
          >
            {isPhone ? (
              <span>
                {" "}
                <i className="icon-clock"></i>
              </span>
            ) : (
              <span className="m-2 "> {t("اتوماسیونها")}</span>
            )}
          </i>
        </div>

        <i
          className="icon-ellipsis-vert cursor"
          style={{ fontSize: "18px" }}
        ></i>
      </div> */}

      {!x ? <Scenarios /> : <Automations />}
    </>
  );
};
export { AutoOrSen };
